export function formatMonthLabel(value) {
  const [year, month] = String(value).split("-");
  const date = new Date(Number(year), Number(month) - 1, 1);
  return date.toLocaleDateString("es-AR", { month: "short", year: "2-digit" }).replace(".", "");
}

export function formatNumber(value) {
  return new Intl.NumberFormat("es-AR").format(Number(value || 0));
}

export function formatMoney(value, currency) {
  const number = Number(value || 0);
  if (currency === "ARS" || currency === "USD") {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }).format(number);
  }
  return formatNumber(number);
}

export function formatDateShort(value) {
  if (!value) return "";
  const date = new Date(`${value}T00:00:00`);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("es-AR", { day: "2-digit", month: "2-digit", year: "2-digit" });
}

export function inclusiveDays(desde, hasta) {
  const start = new Date(`${desde}T00:00:00`);
  const end = new Date(`${hasta}T00:00:00`);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return null;
  return Math.max(1, Math.round((end - start) / 86400000) + 1);
}
